import React from 'react';
import { browserHistory } from 'react-router';
import { trans } from '../localization/language';
import Teleport from './security/verification/Teleport';
import { getRequestParam } from '../utils';
import { isSameDay } from 'date-fns/isSameDay';
import { isValid } from 'date-fns/isValid';

const PASSWORD_UPDATE_REQUIRED_STATUS = 1 << 9;

export default class PasswordUpdateNotice extends React.Component {
	constructor() {
		super();
		this.state = {
			isClosed: false,
		};
		this.handleClose = this.handleClose.bind(this);
	}

	handleClose() {
		this.setState({ isClosed: true });
		localStorage.setItem(
			'closed_password_notice_at',
			new Date().toISOString()
		);
	}

	componentDidMount() {
		const url = getRequestParam('cpn_redirect_url');
		if (url) {
			sessionStorage.setItem('cpn_redirect_url', url);
		}

		const cpn = getRequestParam('cpn');
		if (cpn === '1') {
			this.handleClose();
		} else {
			const closedAt = localStorage.getItem('closed_password_notice_at');
			if (closedAt && isValid(new Date(closedAt))) {
				this.setState({
					isClosed: isSameDay(new Date(), new Date(closedAt)),
				});
			}
		}
	}

	render() {
		const { userInfo } = this.props;
		const shouldNotifyPasswordUpdate = userInfo
			? (userInfo.status & PASSWORD_UPDATE_REQUIRED_STATUS) > 0
			: false;

		if (this.state.isClosed || !shouldNotifyPasswordUpdate) return null;

		return (
			<Teleport>
				<div className="password-update-notice-modal">
					<div className="password-update-notice-modal__dialog">
						<div className="password-update-notice-modal__header">
							<div className="password-update-notice-modal__title">
								{trans('password_update_notice_title')}
							</div>
						</div>
						<div className="password-update-notice-modal__body">
							<div
								className="password-update-notice-modal__message"
								dangerouslySetInnerHTML={{
									__html: trans('password_update_notice_msg'),
								}}
							></div>
						</div>
						<div className="password-update-notice-modal__footer">
							<button
								className="password-update-notice-modal__btn-cancel"
								onClick={this.handleClose}
							>
								{trans('cancel_btn')}
							</button>
							<button
								className="password-update-notice-modal__btn-confirm"
								onClick={() => {
									this.handleClose();
									browserHistory.push(
										'/security/password/init'
									);
								}}
							>
								{trans('change_password_btn')}
							</button>
						</div>
						<button
							className="password-update-notice-modal__close"
							onClick={this.handleClose}
						></button>
					</div>
				</div>
			</Teleport>
		);
	}
}



// WEBPACK FOOTER //
// ./app/components/PasswordUpdateNotice.js